import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router";
import CSSModules from "lib/utils/css-modules";

import st from "lib/utils/index";
import EditButton from "lib/components/EditButton";
import OrderCustomerLink from "lib/components/OrderCustomerLink";
import { open as openShowSlotModal } from "modules/calendar/ShowSlotModal/index";
import styles from "./OrderSidebarPreview.less";
import { Button, Label } from "./vendor";

@connect(
  (state) => ({
    currentCompanyId: state.auth.company.model.id,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        openShowSlotModal,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class OrderSidebarPreview extends React.PureComponent {
  render() {
    const {
      order,
      currentCompanyId,
      extended = true,
      showImage = true,
      showSchedule = true,
      showBill = true,
      showCustomer = true,
      fullHeight = false,
      openShowSlotModal,
      onScheduleSlotEditClick,
    } = this.props;

    let productImageUrl = st.getAttachmentImageUrl(order.product, "main_image", "thumb");
    if (productImageUrl.endsWith(".webp")) {
      productImageUrl = order.product.main_image_file.url;
    }

    return (
      <div
        styleName={classNames("container", {
          "container--fullHeight": fullHeight,
          "container--extended": extended,
        })}
      >
        <div styleName="section--image-with-product">
          {showImage && order.product && order.product.main_image_file && (
            <div styleName="section--image">
              <img src={productImageUrl} />
            </div>
          )}

          <div styleName="section--product">
            <div styleName="section-content">
              {!!order.product && !st.authorize.company.reseller && (
                <Link to={`/c/${currentCompanyId}/products/${order.product.id}/edit`} styleName="product_name">
                  {order.product_name}
                </Link>
              )}
              {!!order.product && st.authorize.company.reseller && (
                <a style={{ fontWeight: 500, fontSize: "16px" }}>{order.product_name}</a>
              )}
              {!order.product && <div styleName="product_name">{order.product_name}</div>}
              {order.product_variant_name && <div styleName="product_variant_name">{order.product_variant_name}</div>}
            </div>
            {order.connectly_order !== undefined ? (
              <Label color="yellow">
                {`${order.connectly_order.connectly_source.name} ${order.connectly_order.source_order_id}`}
              </Label>
            ) : null}
          </div>
        </div>

        {showSchedule && !!order.stock_starts_at && (
          <div styleName="section--slot">
            <div styleName="section-icon">
              <i className="icon material-icons">date_range</i>
            </div>
            <div styleName="section-content">
              {!(order.product_schedule_slot && order.product_schedule_slot.id) && (
                <div styleName="slot_name">
                  {st.formatTimeRange(order.stock_starts_at, order.stock_ends_at, {
                    includeTime: order.stock_includes_time,
                  })}
                </div>
              )}
              {!!(order.product_schedule_slot && order.product_schedule_slot.id) && !st.authorize.company.reseller && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    openShowSlotModal(order.product_schedule_slot);
                  }}
                >
                  <div styleName="slot_name">
                    {st.formatTimeRange(order.stock_starts_at, order.stock_ends_at, {
                      includeTime: order.stock_includes_time,
                    })}
                  </div>
                  {I18n.t("papp.components.OrderSidebarPreview.see_slot")}
                </a>
              )}
              {!!(order.product_schedule_slot && order.product_schedule_slot.id) && st.authorize.company.reseller && (
                <a>
                  <div styleName="slot_name">
                    {st.formatTimeRange(order.stock_starts_at, order.stock_ends_at, {
                      includeTime: order.stock_includes_time,
                    })}
                  </div>
                </a>
              )}
              {!st.authorize.company.reseller && onScheduleSlotEditClick && order.product_type !== "accommodation" && (
                <EditButton
                  label={I18n.t("papp.components.OrderSidebarPreview.edit_slot")}
                  onClick={(e) => {
                    e.preventDefault();
                    onScheduleSlotEditClick();
                  }}
                />
              )}
            </div>
          </div>
        )}

        {showSchedule && (order.stock_useby_starts_at || order.stock_useby_ends_at) && (
          <div styleName="section--slot">
            <div styleName="section-icon">
              <i className="icon material-icons">date_range</i>
            </div>
            <div styleName="section-content">
              <div styleName="slot_description">{I18n.humanAttributeName("order", "stock_useby_time_range")}</div>
              {!order.product_variant && (
                <div styleName="slot_name">
                  {st.formatTimeRange(order.stock_useby_starts_at, order.stock_useby_ends_at, {
                    format: "medium",
                    includeTime: false,
                  })}
                </div>
              )}
              {!order.product_variant && (
                <div styleName="slot_name">
                  {st.formatTimeRange(order.stock_useby_starts_at, order.stock_useby_ends_at, {
                    format: "medium",
                    includeTime: false,
                  })}
                </div>
              )}
              {!!order.product_variant && (
                <Link
                  to={`/c/${currentCompanyId}/products/${order.product.id}/edit?step=booking_settings`}
                  styleName="slot_name"
                >
                  {st.formatTimeRange(order.stock_useby_starts_at, order.stock_useby_ends_at, {
                    format: "medium",
                    includeTime: false,
                  })}
                </Link>
              )}
            </div>
          </div>
        )}
        {showBill && order.product_type === "coupon" && (
          <div styleName="section--bill">
            <div styleName="section-icon">
              <i className="icon material-icons">shopping_cart</i>
            </div>
            <div styleName="section-content">
              {order.coupon_offer_price_before_discount && (
                <div styleName="amount-row amount-row--normal">
                  <div styleName="amount-row-left">{I18n.t("fe.order_details.coupon_offer_price_before_discount")}</div>
                  <div styleName="amount-row-right">{st.formatMoney(order.coupon_offer_price_before_discount)}</div>
                </div>
              )}
              {(order.coupon_discount_amount || order.coupon_discount_percentage) && (
                <div styleName="amount-row amount-row--normal">
                  <div styleName="amount-row-left">{I18n.t("fe.order_details.coupon_discount_amount")}</div>
                  <div styleName="amount-row-right">
                    {(() => {
                      const formattedAmount =
                        order.coupon_discount_amount && st.formatMoney(order.coupon_discount_amount);
                      const formattedPercentage =
                        order.coupon_discount_percentage && `${order.coupon_discount_percentage}%`;
                      if (formattedAmount && formattedPercentage) {
                        return `${formattedAmount} (${formattedPercentage})`;
                      } else {
                        return formattedAmount || formattedPercentage;
                      }
                    })()}
                  </div>
                </div>
              )}

              {order.coupon_offer_price && (
                <div styleName="amount-row amount-row--normal">
                  <div styleName="amount-row-left">{I18n.t("fe.order_details.coupon_offer_price")}</div>
                  <div styleName="amount-row-right">
                    <strong className="text-primary">{st.formatMoney(order.coupon_offer_price)}</strong>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {showBill && order.has_pricing && order.ordered_product_pricelist_items.length > 0 && (
          <div styleName="section--bill">
            <div styleName="section-icon">
              <i className="icon material-icons">people</i>
            </div>
            <div styleName="section-content">
              {order.ordered_product_pricelist_items
                .filter((oi) => oi.quantity > 0)
                .map((orderedItem) => (
                  <div styleName="ordered_item" key={orderedItem.uuid}>
                    {orderedItem.full_display_name}
                  </div>
                ))}
            </div>
          </div>
        )}
        {order.nights_count > 0 && (
          <div styleName="section--bill">
            <div styleName="customer-meta">
              <span className="with-icon">
                <i className="icon material-icons">nights_stay</i>
                <span className="text">
                  {order.nights_count === 1
                    ? I18n.t("papp.orders.ShowOrderView.one_night", {
                        i: order.nights_count,
                      })
                    : I18n.t("papp.orders.ShowOrderView.nights", {
                        i: order.nights_count,
                      })}
                </span>
              </span>
            </div>
          </div>
        )}
        {showCustomer && (
          <div styleName="section--customer">
            <div styleName="section-icon">
              <i className="icon material-icons">person</i>
            </div>
            <div styleName="section-content">
              <div styleName="customer_full_name" disabled={!order.customer_full_name}>
                <OrderCustomerLink order={order} currentCompanyId={currentCompanyId} />
              </div>
              {!!order.customer_phone_number && (
                <div styleName="customer_phone_number">
                  <span className="with-icon">
                    <i className="icon material-icons">phone</i>
                    <span className="text">{order.customer_phone_number}</span>
                  </span>
                </div>
              )}
              {!!order.customer_email && (
                <div styleName="customer_email">
                  <span className="with-icon">
                    <i className="icon material-icons">email</i>
                    <span className="text">{order.customer_email}</span>
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        {showBill && order.has_pricing && !!(order.total_amount_sum && order.total_amount_sum.length > 0) && (
          <div styleName="section--total_amount">
            <div styleName="amount-row amount-row--total">
              <div styleName="amount-row-left">{I18n.t("fe.order_details.total_amount_short")}</div>
              <div styleName="amount-row-right">{st.formatMoney(order.total_amount_sum)}</div>
            </div>
          </div>
        )}

        {showBill && order.has_pricing && (
          <div styleName="section--paid_amount">
            {!!(order.paid_amount_sum && order.paid_amount_sum.length > 0) && (
              <div styleName="amount-row amount-row--total">
                <div styleName="amount-row-left">{I18n.t("fe.order_details.paid_amount")}</div>
                <div styleName="amount-row-right">{st.formatMoney(order.paid_amount_sum)}</div>
              </div>
            )}

            {!!(order.refunded_amount_sum && order.refunded_amount_sum.length > 0) && (
              <div styleName="amount-row amount-row--total">
                <div styleName="amount-row-left">{I18n.t("fe.order_details.refunded_amount")}</div>
                <div styleName="amount-row-right">{st.formatMoney(order.refunded_amount_sum)}</div>
              </div>
            )}
            {!order.withdrawn &&
              !!(order.remaining_total_amount_sum && order.remaining_total_amount_sum.length > 0) && (
                <div styleName="amount-row amount-row--total">
                  <div styleName="amount-row-left">{I18n.t("fe.order_details.remaining_total_amount_short")}</div>
                  <div styleName="amount-row-right">{st.formatMoney(order.remaining_total_amount_sum)}</div>
                </div>
              )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/OrderSidebarPreview.jsx